import React from 'react';

interface ThankYouPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

const ThankYouPopup: React.FC<ThankYouPopupProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center z-50">
      <div className="relative p-8 bg-white w-full max-w-md m-auto flex-col flex rounded-lg shadow-lg">
        <button 
          onClick={onClose} 
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold"
        >
          &times;
        </button>
        <div className="text-center">
          {/* You can replace this with your actual logo */}
          <h2 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 mb-4">
            IgniLead
          </h2>
          <p className="text-xl font-semibold text-gray-700 mb-2">Thank You!</p>
          <p className="text-gray-600 mb-6">Your submission has been received. We will be in contact shortly.</p>
          <button
            onClick={onClose}
            className="w-full py-3 px-6 bg-gradient-to-r from-purple-500 to-purple-600 text-white font-semibold rounded-md hover:from-purple-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPopup; 